// Unpublished Work © 2025 Deere & Company.
import {createUserSession} from '../user-session-details';

const isValidArgs = (applicationName, userId) => applicationName && userId;

const buildSessionKey = (applicationName, userId) =>
    `entryLogged_${applicationName}_${userId}`;

const hasLogged = (sessionKey) => sessionStorage.getItem(sessionKey);

const markLogged = (sessionKey) => sessionStorage.setItem(sessionKey, 'true');

export const logUserEntryOnce = (applicationName, userId) => {
    if (!isValidArgs(applicationName, userId)) {
        return;
    }

    const sessionKey = buildSessionKey(applicationName, userId);

    if (hasLogged(sessionKey)) {
        return;
    }

    createUserSession(userId, applicationName);
    markLogged(sessionKey);
};
